import Sidebar from "../../components/sidebar";
import InfoCenter from "../../components/info-center";
import Loading from "../../components/loading";
import Formulario from "../../components/formulario";
import React, {useState} from "react";
import {redirect} from "react-router-dom";
import SaveInfoConsulta from "../../api/save-info-consulta";
import './style.css';
import Header from "../../components/header";
export default function Consulta() {

    const [error, setError] = useState("");
    const [loadingComplete] = useState(false);
    if (error !== "") {
        console.log(error);
        setError("");
        return redirect("/error");
    }

    const saveConsulta = new SaveInfoConsulta()

    saveConsulta.delete('data_consulta')

    return (
        <Sidebar>
            <>
                <Header />

                <div className="pagina-conteudo">
                    <div className="pagina-tabela">
                        <Formulario saveConsulta={saveConsulta}/>
                        <div>
                            {loadingComplete ? (
                                Loading()
                            ) : (
                                <InfoCenter/>
                            )}
                        </div>

                    </div>
                    <p className="texto-info">
                        Esta página foi criada para atender ao Art.23, da Portaria Nº 1095/2018, de 25 de outubro
                        de 2018, e constam nela APENAS os
                        Diplomas dos cursos de Graduação expedidos pela
                        UNISUAM a partir de 25 de abril de 2019.
                        Se você se formou anteriormente a esta data, o seu Diploma não está disponível nesta
                        plataforma, mas continua sendo válido desde a sua emissão.
                    </p>
                </div>
            </>

        </Sidebar>
    );
}
